import PropTypes from 'prop-types'

const BorderCoordListPropType = PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.array))

export default BorderCoordListPropType
